/* import __COLOCATED_TEMPLATE__ from './linking.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { wait } from '@banking/ui/utils/wait';
import { setGrantAction, setOnboardingScreenAction } from '@banking/ui/workflows/investments';
import environment from '@square/environment-utils/environment';
const DISPLAY_TIME_FOR_ERROR = 2500;
const CONTAINER_ID = '#cash-app-pay';
const DELAY_TIME_BEFORE_DISPLAYING_SUCCESS = 2000;
let Linking = (_class = class Linking extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor, this);
    _initializerDefineProperty(this, "cashAppPayKitSdk", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _initializerDefineProperty(this, "merchantMainUnit", _descriptor4, this);
    _initializerDefineProperty(this, "assetMap", _descriptor5, this);
    _initializerDefineProperty(this, "userInfo", _descriptor6, this);
    _initializerDefineProperty(this, "intl", _descriptor7, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor8, this);
    _initializerDefineProperty(this, "dataApi", _descriptor9, this);
    _initializerDefineProperty(this, "isLoading", _descriptor10, this);
    _initializerDefineProperty(this, "loadingError", _descriptor11, this);
    _initializerDefineProperty(this, "isButtonLoading", _descriptor12, this);
    _initializerDefineProperty(this, "merchantInfo", _descriptor13, this);
    _initializerDefineProperty(this, "accountSelected", _descriptor14, this);
    _initializerDefineProperty(this, "displayValueProp", _descriptor15, this);
    _defineProperty(this, "_goBack", () => null);
    _defineProperty(this, "close", () => null);
    _defineProperty(this, "beginPayKit", () => Promise.resolve());
    // https://developers.cash.app/docs/pay-kit-technical-reference#restart
    // restart must be called whenever the buyer leaves the screen
    _defineProperty(this, "restartPayKit", () => Promise.resolve());
    this._goBack = args.goBack;
    this.close = args.close;
    this.displayValueProp = args.displayValueProp;
    this.init();
  }
  async init() {
    this.merchantInfo = await this.getMerchantInfo();
    this.isLoading = false;
  }
  async beginPay() {
    this.isButtonLoading = true;
    const {
      error
    } = await this.initCashAppScript();
    this.isButtonLoading = false;

    // display an error message breifly before going back to the splash screen
    if (error) {
      this.loadingError = true;
      await wait(DISPLAY_TIME_FOR_ERROR);
      this.loadingError = false;
      this.close();
    } else {
      this.beginPayKit();
      this.close();
    }
  }
  async initCashAppScript() {
    const onSuccessCallback = result => {
      const {
        grants: {
          deposits: {
            grantId
          }
        },
        customerProfile: {
          cashtag
        }
      } = result;

      // delay to allow PayKit modal to close before showing the account-relationship step
      setTimeout(() => {
        this.investmentsWorkflow.emit(setGrantAction(grantId, cashtag));
      }, DELAY_TIME_BEFORE_DISPLAYING_SUCCESS);
    };
    try {
      const env = environment();
      const redirectURL = env.isStaging ? 'https://squareupstaging.com/dashboard/balances' : 'https://squareup.com/dashboard/balances';
      const controls = await this.cashAppPayKitSdk.initialize({
        container: CONTAINER_ID,
        redirectURL,
        onSuccessCallback,
        actionData: this.merchantInfo,
        isMobileFlow: false
      });
      if (!controls) {
        throw new Error('Cash App Pay Kit: failed to load');
      }

      // match the PayKit modal styles to Dashboard
      this.adjustModalStyles();
      this.beginPayKit = controls.begin;
      this.restartPayKit = controls.restart;
      return {};
    } catch (error) {
      this.sentry.captureException(error);
      return {
        error
      };
    }
  }
  async getMerchantInfo() {
    // make the url dynamic
    // this is a workaround to avoid double-prefixing a static URL
    // https://square.slack.com/archives/C0254AEKX/p1672861761147609?thread_ts=1672856947.549599&cid=C0254AEKX
    const countryCode = this.userInfo.countryCode;
    const defaultLogoUrl = this.assetMap.resolve(`@banking/ui/assets/images/investments/square-${countryCode}.png`);
    const mainUnit = await this.merchantMainUnit.findMainUnit();
    const logoUrl = mainUnit?.merchantProfile?.profileImage?.square60_url || defaultLogoUrl;
    const merchantName = mainUnit?.merchantProfile?.name || this.userInfo.name || this.intl.t('banking.investments.automation.create.linking.valueprop.fallbackName');
    return {
      primary_alias: merchantName,
      logo_url: logoUrl
    };
  }
  goNext() {
    // value prop screen
    if (this.displayValueProp) {
      this.displayValueProp = false;
      return;
    }

    // account selection screen
    if (this.accountSelected === 'current') {
      this.beginPay();
      return;
    }

    // new account screen
    if (this.accountSelected === 'new') {
      this.investmentsWorkflow.emit(setOnboardingScreenAction('linkingNewAccount'));
    }
  }
  goBack() {
    // value prop screen
    if (this.displayValueProp) {
      this.restartPayKit();
      this._goBack();
      return;
    }

    // account selection screen
    this.displayValueProp = true;
  }
  selectAccount(accountType) {
    this.accountSelected = accountType;
  }
  adjustModalStyles() {
    const payStyleOverrides = document.createElement('style');
    payStyleOverrides.innerHTML = `
      [data-testid="dialog-overlay"] {
        background-color: rgba(0, 0, 0, 0.8);
      }
      [data-testid="dialog-body"] {
        position: absolute;
        top: 56px;
      }
    `;
    document.querySelector(`${CONTAINER_ID} div`)?.shadowRoot?.appendChild(payStyleOverrides);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashAppPayKitSdk", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "merchantMainUnit", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "loadingError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isButtonLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "merchantInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      primary_alias: '',
      logo_url: ''
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "accountSelected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "displayValueProp", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "beginPay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "beginPay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goNext", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goNext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBack", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAccount"), _class.prototype)), _class);
export { Linking as default };